export enum ZipConstants {
  SET_ZIP_STATE = 'zip/SET_ZIP_STATE',
  SET_ZIP_RESPONSE = 'zip/SET_ZIP_RESPONSE',
  SET_ALERT_MESSAGE = 'zip/SET_ALERT_MESSAGE',
}
